import React from "react";
import { useT, useI18n } from "@/i18n";
import { Link } from "react-router-dom";

export default function Logo({ className = "", withText = true, size = 40 }) {
  const t = useT();
  const { lang } = useI18n();
  return (
    <Link
      to={`/${lang}`}
      className={`inline-flex items-center gap-3 group ${className}`}
      aria-label={t("a11y.logoAlt")}
      data-testid="logo-link"
    >
      <span
        className="relative inline-flex items-center justify-center rounded-full ring-1 ring-white/15 bg-[#0d131b] shadow-inner"
        style={{ width: size, height: size }}
      >
        <svg
          viewBox="0 0 64 64"
          width={size - 8}
          height={size - 8}
          aria-hidden="true"
          className="text-[#C9F14B]"
        >
          <defs>
            <radialGradient id="zr-glow" cx="50%" cy="50%" r="55%">
              <stop offset="0%" stopColor="#C9F14B" stopOpacity="0.35" />
              <stop offset="100%" stopColor="#C9F14B" stopOpacity="0" />
            </radialGradient>
          </defs>
          <circle cx="32" cy="32" r="26" fill="url(#zr-glow)" />
          <circle cx="32" cy="32" r="20" fill="none" stroke="currentColor" strokeOpacity="0.25" strokeWidth="1" />
          <circle cx="32" cy="32" r="12" fill="none" stroke="currentColor" strokeOpacity="0.55" strokeWidth="1" />
          <path
            d="M32 8 A24 24 0 0 1 55 30"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            className="transition-transform duration-700 group-hover:rotate-45 origin-center"
            style={{ transformOrigin: "32px 32px" }}
          />
          <path
            d="M18 44 L28 30 L34 36 L46 22"
            fill="none"
            stroke="currentColor"
            strokeWidth="2.4"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <circle cx="46" cy="22" r="2.6" fill="currentColor" />
        </svg>
      </span>
      {withText && (
        <span className="flex flex-col leading-tight">
          <span className="text-[15px] tracking-[0.02em] text-[#F1ECDE] font-semibold">Zenithradiar</span>
          <span className="text-[10px] tracking-[0.28em] uppercase text-[#8f96a3]">Buenos Aires</span>
        </span>
      )}
    </Link>
  );
}
